import apiClient from "@/services/api-client";

export const adminWorkspaceService = {
  summary: async () => (await apiClient.get("/workspace/summary")).data,
  savedViews: async (resourceType?: string) =>
    (
      await apiClient.get("/workspace/saved-views", {
        params: { resourceType },
      })
    ).data,
  createSavedView: async (payload: Record<string, unknown>) =>
    (await apiClient.post("/workspace/saved-views", payload)).data,
  setDefaultSavedView: async (id: string) =>
    (await apiClient.patch(`/workspace/saved-views/${id}/default`)).data,
  deleteSavedView: async (id: string) =>
    (await apiClient.delete(`/workspace/saved-views/${id}`)).data,
  notifications: async (unreadOnly = false) =>
    (
      await apiClient.get("/workspace/notifications", {
        params: { unreadOnly },
      })
    ).data,
  markNotificationRead: async (id: string) =>
    (await apiClient.patch(`/workspace/notifications/${id}/read`)).data,
  markAllNotificationsRead: async () =>
    (await apiClient.patch("/workspace/notifications/read-all")).data,
  dismissNotification: async (id: string) =>
    (await apiClient.patch(`/workspace/notifications/${id}/dismiss`)).data,
  reportSchedules: async () =>
    (await apiClient.get("/workspace/report-schedules")).data,
  createReportSchedule: async (payload: Record<string, unknown>) =>
    (await apiClient.post("/workspace/report-schedules", payload)).data,
  setReportScheduleStatus: async (id: string, isActive: boolean) =>
    (
      await apiClient.patch(`/workspace/report-schedules/${id}/status`, {
        isActive,
      })
    ).data,
  reportRuns: async () => (await apiClient.get("/workspace/report-runs")).data,
  runReport: async (payload: Record<string, unknown>) =>
    (await apiClient.post("/workspace/report-runs", payload)).data,
};
